import { Injectable } from '@angular/core';
import { ServerTokenService } from './server-token.service';
import { CaseProcessNames, Job, LeGeneralData, LePdfData, PdfData } from 'shared-types';
import { calculateBMI } from 'shared';

@Injectable({
  providedIn: 'root'
})
export class WorkflowService {
  confirmPayment(data: any) {
    return this.server.postWithToken('workflow/confirmPayment', { dirName: this.variables.generalDataProcess.dirName, data: data}).toPromise()
  }


  variables = new Variables()
  constructor(private server: ServerTokenService) { }

  process() {
    let fileArray = this.variables.generalDataProcess.files.length > 0 ? this.variables.generalDataProcess.files : null
    this.server.postWithToken('workflow/start', {
      id: this.variables.processData.jobId,
      fileArray: fileArray
    }).subscribe((data: Job) => {
      this.variables.processData.timeToPrediction = 15
      this.checkStatus(data.jobId)
      this.variables.processSteps.isProccecing = true;
    })
  }

  createJob() {
    return this.server.postWithToken('workflow/createJob', {
      runTime: 1000 * 15, 
      dirName: this.variables.generalDataProcess.dirName,
      files: this.variables.generalDataProcess.files.map((file) => ({
        name: file.name,
        size: file.size,
        type: file.type,
        lastModified: file.lastModified,
        numOfPages: file.numOfPages,
      })),
      jobs: this.variables.generalDataProcess.jobs, 
      Name: this.variables.generalDataProcess.patientName, 
      hippaFiles: this.variables.generalDataProcess.hippaFiles ? this.variables.generalDataProcess.hippaFiles.map((file) => ({
        name: file.name,
        size: file.size,
        type: file.type,
        lastModified: file.lastModified,
        numOfPages: file.numOfPages,
      })) : null
    })
  }

  isError(): ErrorTypes {
    if(this.variables.processData.generalInfoValues.Age > 90){
      return ErrorTypes.OverAge;
    }
    if(this.variables.processData.generalInfoValues.Age <= 65) {
      return ErrorTypes.UnderAge;
    }
    if(this.variables.processSteps.isError){
      return ErrorTypes.ServerError;
    }
    return undefined;
  }
  updateListFiles(files: any[]) {
    for (let i = 0; i < files.length; i++) {
      this.variables.generalDataProcess.files.push(files[i]);
    }
  }

  updateHippaFiles(files: any[]) {
    for (let i = 0; i < files.length; i++) {
      this.variables.generalDataProcess.hippaFiles.push(files[i]);
    }
  }

  checkStatus(jobId) {
    this.server.postWithToken<any>('workflow/getJobStatus', { jobId: jobId }).subscribe((data: Job) => {
      if (!data.continue) {
        return
      }
      this.setData(data)
      if (!this.variables.processSteps.isPdfDone) {
        setTimeout(this.checkStatus.bind(this), 2000, jobId);
      }
    })
  }

  setData(data: Job) {
    if( data && data.error){
      this.variables.processSteps.isError = true
      return;
    }
    if (data && data.hippaFiles.length > 0) {
      this.variables.processSteps.hippaFilesUpdated = true
    }
    if (data && data.files) {
      // this.variables.generalDataProcess.files = data.files;
    }
    if (data && data.generalInfo) {
      // if(Number(data.generalInfo.Age) < 65 ){
      //   alert('Invalid age (under 65), the process will stop. Please try again with a valid age')
      //   this.variables.workerService.reset()
      //   return
      // }
      this.editGeneralInfo(data.generalInfo)
      if(data.generalInfo.Age > 90 || data.generalInfo.Age < 60) {
        this.resetProcessData()
      }
    }
    if (data && data.jobId && !this.variables.processData.jobId) {
      this.variables.processData.jobId = data.jobId
    }
    if (data && data.pdfData) {
      this.variables.pdfData = data.pdfData;
      this.variables.processData.pdfPath = data.pdfData.pdfName
    }
    if (data && data.company) {
      this.variables.generalDataProcess.company = data.company
    }
    if (data && data.createdBy) {
      this.variables.generalDataProcess.createdBy = data.createdBy
    }
    if (data && data.createdDate) {
      this.variables.generalDataProcess.createdDate = data.createdDate.split(',')[0]
    }
    if(data && data.dirName){
      this.variables.generalDataProcess.dirName = data.dirName
    }
    if (data && data.prediction) {
      this.variables.processSteps.isLeDone = true;
    }
    if(data && data.pdfData && data.pdfData.isPdfReady){
      this.proccessPrediction(data.pdfData.leData)
      this.variables.processSteps.isPdfDone = true
      this.variables.processSteps.isProccecing = false
      return   
    }
  }

  resetProcessData() {
    if (this.variables.processSteps.isProccecing) {
      this.stopProcess()
    }
    let termsConfirmation = this.variables.generalDataProcess.termsConfirmation
    this.variables = new Variables()
    this.variables.generalDataProcess.termsConfirmation = termsConfirmation
  }

  editGeneralInfo(data: any) {
    this.variables.processData.generalInfoKeys = Object.keys(data);
    let genInfo = {}
    for (let i = 0; i < this.variables.processData.generalInfoKeys.length; i++) {
      let key = this.variables.processData.generalInfoKeys[i]
      if (key.includes('Date') || key.includes('date') || key.includes('DOB')) {
        genInfo[key] = new Date(data[key]).toLocaleDateString();
      } else if (key.includes('age') || key.includes('Age')) {
        genInfo[key] = Number(data[key]).toFixed(1);
      }
      else if (key.includes('BMI') || key.includes('bmi')) {
        genInfo[key] = Number(calculateBMI(Number(data['Weight']), Number(data['Height']))).toFixed(1);
      }
      else {
        genInfo[key] = data[key];
      }
    }
    this.variables.processData.generalInfoValues = genInfo;
  }

  proccessPrediction(prediction: LePdfData) {
    this.variables.processData.generalInfoValues['Life Expectancy Mean'] = prediction.average
    this.variables.processData.generalInfoValues['Life Expectancy Median'] = prediction.median
    this.variables.processData.leData['lives'] = prediction.lives
    this.variables.processData.leData['dies'] = prediction.projectedDeath
    this.variables.processData.leTablesData['lives'] = prediction.livesTable
    this.variables.processData.leTablesData['dies'] = prediction.projectedDeathTable
  }



  CheckTermsConfirmation() {
    return this.server.getWithToken(`workflow/checkTermsConfirmation`)
  }

  updateTermsConfirmation(value: boolean) {
    this.server.postWithToken(`workflow/updateTermsConfirmation`, { termsConfirmation: value }).subscribe((data: any) => {
      this.variables.generalDataProcess.termsConfirmation = data.termsConfirmation
    })
  }

  processDemo() {
  }

  stopProcess() {
    // this.server.postWithToken(`workflow/stop/${this.variables.processData.jobId}`, {}).subscribe(data => {
    //   console.log(data);
    // })
  }

  updateName() {
    if (this.variables.processData.jobId && this.variables.processSteps.isProccecing) {
      this.server.postWithToken(`workflow/updateName/${this.variables.processData.jobId}`, { Name: this.variables.generalDataProcess.patientName }).subscribe(data => {
        console.log(data);
      })
    }
  }

  updatePayment() {
    if (this.variables.priceDetails.needToPay <= 0) {
      let body = {
        key: 'piad',
        value: true
      }
      this.server.postWithToken(`workflow/updateJob/${this.variables.processData.jobId}`, body).subscribe(data => {
        console.log(data);
      })
    }
  }

  updateUrl() {
    let body = {
      key: 'pdfUrl',
      value: this.variables.processData.pdfPath
    }
    this.server.postWithToken(`workflow/updateJob/${this.variables.processData.jobId}`, body).subscribe(data => {
      console.log(data);
    })
  }

  updateHippaFilesInJob() {
    if (!this.variables.processSteps.hippaFilesUpdated) {
      let body = {
        value: this.variables.generalDataProcess.hippaFiles.map((file) => ({
          name: file.name,
          size: file.size,
          type: file.type,
          lastModified: file.lastModified,
          numOfPages: file.numOfPages,
        })),
        key: 'hippaFiles'
      }
      this.server.postWithToken(`workflow/updateJob/${this.variables.processData.jobId}`, body).subscribe(data => {
        console.log(data);
      })
    }
  }


}

class Variables {

  user = JSON.parse(localStorage.getItem('currentUser'));
  generalDataProcess: GeneralDataPerProcess = {
    patientName: { firstName: null, lastName: null },
    files: [],
    hippaFiles: [],
    dirName: null,
    jobs: [],
    dirIndex: null,
    demo: this.user ? this.user['role'] < 100 ? true : false : null,
    totalPages: 0,
    processId: null,
    createdBy: null,
    createdDate: null,
    company: null,
    termsConfirmation: null
  };

  uploadProcess: FileUpload = {
    isFileUploadProccess: false,
    isFileUploadProccessDone: false,
  };

  processSteps: ProcessSteps = {
    isProccecing: false,
    isLeDone: false,
    hippaFilesUpdated: false,
    jobCreated: false,
    isPdfDone: false,
    isError: false
  };

  pdfData: PdfData;

  processData: ProcessData = {
    generalInfoKeys: [],
    generalInfoValues: [],
    prediction: null,
    leData: {},
    leTablesData: {},
    jobId: null,
    timeToPrediction: 0,
    pdfPath: null
  };

  priceDetails: PriceDetails = {
    basic: 0,
    Tax: 0,
    discount: 0,
    pc: false,
    paid: 0,
    needToPay: 0
  }
}



type OneFileUpload = {
}

type FileUpload = {
  isFileUploadProccess: boolean;
  isFileUploadProccessDone: boolean;
}

type ProcessSteps = {
  isProccecing: boolean;
  isLeDone: boolean;
  hippaFilesUpdated: boolean;
  jobCreated: boolean,
  isPdfDone: boolean
  isError: boolean
}

type ProcessData = {
  generalInfoKeys: string[];
  generalInfoValues: any;
  prediction: LeGeneralData
  leData: any
  leTablesData: any
  jobId: string
  timeToPrediction: number,
  pdfPath: string

}

type GeneralDataPerProcess = {
  patientName: { firstName: string; lastName: string };
  files: any[];
  hippaFiles: any[];
  dirName: string,
  jobs: CaseProcessNames[]
  dirIndex: string
  demo: boolean
  totalPages: number
  processId: string
  createdBy: string;
  createdDate: string;
  company: string;
  termsConfirmation: boolean

}

type PriceDetails = {
  basic: number;
  Tax: number;
  discount: number;
  pc: boolean
  paid: number;
  needToPay: number;
}


export enum ErrorTypes {
  MissingDOB = 2,
  MissingGender = 4,
  ServerError = 8,
  UnderAge = 16,
  OverAge = 32
}